import { noop } from "lodash";

import {
  ANALYSIS_PROVIDERS_ACTIONS,
  COMPANIES_ACTIONS,
  DRIVERS_ACTIONS,
  INTEGRATIONS_ACTIONS,
  INTEGRATIONS_API_ACTIONS,
  ROUTES,
  USERS_ACTIONS,
  VEHICLES_ACTIONS
} from "../../../../shared";
import { useReleaseFeatureToggle } from "../../../../shared/featureToggles/hooks/useReleaseFeatureToggle";
import { FEATURE_NAMES } from "../../../../shared/featureToggles/types";
import SharedToolbar from "./SharedToolbar";

interface TableHeadActionsProps {
  route: ROUTES;
  toggleActiveHead?: (value: boolean) => void;
}

const TableHeadActions = ({
  route,
  toggleActiveHead
}: TableHeadActionsProps) => {
  const { isReleaseFeatureEnabled } = useReleaseFeatureToggle();

  const companyActions = isReleaseFeatureEnabled(
    FEATURE_NAMES.ShowDeleteCompanyButton
  )
    ? [COMPANIES_ACTIONS.DeleteCompany]
    : null;

  const resourceActions = (() => {
    switch (route) {
      case ROUTES.Vehicles:
        return [
          VEHICLES_ACTIONS.QuickScheduleDownload,
          VEHICLES_ACTIONS.RemoveSchedules,
          VEHICLES_ACTIONS.MoveVehicles,
          VEHICLES_ACTIONS.Activate,
          VEHICLES_ACTIONS.Deactivate,
          VEHICLES_ACTIONS.DeleteVehicle
        ];
      case ROUTES.Drivers:
        return [
          DRIVERS_ACTIONS.BulkQuickScheduleDownload,
          DRIVERS_ACTIONS.RemoveSchedules,
          DRIVERS_ACTIONS.DeleteDriver
        ];
      case ROUTES.Companies:
        return companyActions;
      case ROUTES.Users:
        return [USERS_ACTIONS.DeleteUser];
      case ROUTES.Integrations:
        return [INTEGRATIONS_ACTIONS.DeleteIntegration];
      case ROUTES.IntegrationsApi:
        return [INTEGRATIONS_API_ACTIONS.DeleteCredential];
      case ROUTES.AnalysisProviders:
        return [ANALYSIS_PROVIDERS_ACTIONS.Delete];

      default:
        return null;
    }
  })();

  return (
    <SharedToolbar
      route={route}
      resourceActions={resourceActions}
      toggleActiveHead={toggleActiveHead || noop}
    />
  );
};

export default TableHeadActions;
